/* eslint-disable no-case-declarations */
/* eslint-disable complexity */
import { merge, mergeWith, unset } from 'lodash';
import { AnyAction } from 'redux';

import { ActionSet } from '../types';
import { addStale, removeFromStale } from './cache-invalidation-utils';
import {
  DELETE_NORMALISED,
  DELETE_NORMALISED_FLUSH,
  GET_NORMALISED,
  NORMALISATION_FLAGS,
  PUT_NORMALISED
} from './constants';
import { NormalisedStoreState } from './types';
import { mergeWithCustomiser } from './utils';

const init: NormalisedStoreState = { entities: {}, requests: {} };

/**
 * Abstract redcucer for normalised data coming back.
 *
 * @param {ActionSet} actionSet
 * @returns {Reducer}
 */
export const abstractNormalisedIdReducer = (actionSet: ActionSet) => (state: string[] = [], action: AnyAction) => {
  switch (action.type) {
    case actionSet.ACTION:
    case actionSet.FULFILLED:
      return action.payload;
    default:
      return state;
  }
};

/**
 * Reducer for normalised data. Only accepts PUT and GET requests against it.
 * PUT will merge the given payload entities with the existing store.
 * GET will just return the current store.
 *
 * @param {NormalisedData<{}>} state
 * @param {AnyAction} action
 * @returns {NormalisedData<{}>}
 */
export const normalised = (state: NormalisedStoreState = init, action: AnyAction) => {
  switch (action.type) {
    case NORMALISATION_FLAGS.FLUSH_REQUEST_URL: {
      const { type: entityType, url } = action.payload;
      unset(state, `requests[${entityType}][${url}]`);
      return Object.assign({}, state);
    }

    case NORMALISATION_FLAGS.FLUSH_REQUEST_ENTITY: {
      const { type } = action.payload;
      unset(state, `requests[${type}]`);
      return Object.assign({}, state);
    }

    case DELETE_NORMALISED_FLUSH:
    case DELETE_NORMALISED.ACTION:
      return Object.assign({}, state, {
        entities: action.payload.normalised.entities,
        requests: action.payload.normalised.requests
      });

    case NORMALISATION_FLAGS.MARK_AS_STALE:
      addStale(action.payload);
      return state;

    case PUT_NORMALISED.ACTION: {
      const { normalisedData, entity, path } = action.payload;
      let request = {};
      if (entity && path) {
        const ids: string[] = normalisedData.result;
        request = {
          [entity]: {
            [path]: ids
          }
        };
      }

      removeFromStale(path);

      const mergedEntities = mergeWith({}, state.entities, normalisedData.entities, mergeWithCustomiser);
      if (entity === 'Consolidation') {
        // replace, rather than merge the old with the new
        mergedEntities[entity] = normalisedData.entities[entity];
      }
      const mergedRequests = merge({}, state.requests, request);
      return {
        ...state,
        entities: mergedEntities,
        requests: mergedRequests
      };
    }
    case GET_NORMALISED.ACTION:
    default:
      return state;
  }
};
